namespace Areas.Account.RechargeJob{
    "use strict";

    let workOrderId: number;
    let accountId: number;
    let projectCCNumber: string;
    let projectId: number;

    const baseUrl = "/Account/FinanceRechargeJob";


    export function onGridSelectionChanged(e: any) {
        var rowData: any = e.selectedRowsData[0];

        var rowForm: any = $("#RechargeJobForm").dxForm("instance");
        rowForm.option("formData", rowData);

        let selectedRows = e.component.getSelectedRowsData();
        workOrderId = selectedRows[0].accountWorkOrderId;
    }

    export function onRechargeJobContentReady(e: any) {
        if (!e.component.getSelectedRowKeys().length)
            e.component.selectRowsByIndexes(0);
    }

    export function addRechargeJob() {
        const form = $("#RechargeJobForm").dxForm("instance");
        const formData: any = form.option("formData");
        accountId = formData.accountId;
        projectCCNumber = formData.projectCCNumber;
        workOrderId = 0;

        $.get(`${baseUrl}/AddRechargeJob/${accountId}/${projectCCNumber}`,
            (data) => {
                form.option("formData", data);
            });

    }

    export function copyRechargeJob() {
        const form = $("#RechargeJobForm").dxForm("instance");
        const formData: any = form.option("formData");

        let accountWorkOrderId = formData.accountWorkOrderId;

        
        $.get(`${baseUrl}/CopyRechargeJob/${accountWorkOrderId}`,
            (data) => {
                Areas.reloadPage();
            });

    }

    export function updateRechargeJob() {
        const form = $("#RechargeJobForm").dxForm("instance");
        const newData: any = form.option("formData");

        if (newData.accountWorkOrderId == 0) {
            saveRecord(newData);
        } else {
            updateRecord(newData)
        }
    }

    function saveRecord(newData: any) {
        const url = `${baseUrl}/RechargeJobPost`;
        const method = "POST";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
            });
    }

    function updateRecord(newData: any) {
        const url = `${baseUrl}/RechargeJobPut/${workOrderId}`;
        const method = "PUT";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
            });
    }


    // select account

    function dialogProjectClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const form: any = $("#RechargeJobForm").dxForm("instance");
        const formData: any = form.option("formData");


        formData.accountId = data.accountId;
        formData.accountName = data.accountName;
        formData.projectCCNumber = data.projectCCNumber;

        form.option("formData", formData);
    }


    export function selectAccount() {
        const form: any = $("#RechargeJobForm").dxForm("instance");
        projectId = form.option("ProjectId");

        const parameters = { projectId: projectId };

        const projectLookupDialog =
            new Areas.Dialogs.Project.ProjectLookupDialog(dialogProjectClosing, parameters);
    }

}